// React
import React from 'react'
import stringify from 'json-stable-stringify'
// GraphQL
import { graphql } from 'react-apollo'
// GraphQL mutations
import { lookupUpdateMutation } from '../../graphql/mutations/user'
// Components
import Button from '../Display/Button'
import EntryForm from './EntryForm'
import LifePurposeApp from '../Footer/LifePurposeApp'
import Loading from '../Display/Loading'
import Logo from '../Display/Logo'
import Social from '../Display/Social'
import Tab from './Tab'


const emptyState = {
	birthDate: { day: 0, month: 0, year: 0 },
	birthPlace: { address: '', lat: 0, lng: 0 },
	birthTime: { hour: -1, minute: -1, pm: false, timezone: 'America/New_York', utcOffset: 0 },
	birthSigns: {
		sun: { degree: 0, minute: 0, name: '' },
		moon: { degree: 0, minute: 0, name: '' }
	}
}

class Lookup extends React.Component {

	constructor(props) {
		super(props)
		this.state = {
			loading: { status: false, text: '' },
			data: emptyState
		}
	}

	componentWillMount() {
		if (this.props.user.lookup) {
			this.setState({ data: { ...this.props.user.lookup } })
		}
	}

	componentDidMount() {
		window.scrollTo(0, 0)
	}

	componentWillReceiveProps(nextProps) {
		if (stringify(this.props.user.lookup) !== stringify(nextProps.user.lookup)) {
			this.setState({ data: { ...nextProps.user.lookup } })
		}
	}


	// GRAPHQL
	updateBirthData = (birthDate, birthPlace, birthTime, birthSigns) => {
		this.setState({
			data: { birthDate, birthPlace, birthTime, birthSigns },
			loading: { status: true, text: 'Loading...' }
		})
		if (this.props.user) {
			this.props.updateLookup({ variables: { id: this.props.user.id, lookup: this.state.data } })
				.then(() => {
					// Load page
					this.props.redux.nav.addPage(birthSigns.moon.name, { name: birthSigns.moon.name, degree: birthSigns.moon.degree, minute: birthSigns.moon.minute })
				})
				.catch((err) => console.error(err))
		}
		else {
			// Load page
			this.props.redux.nav.addPage(birthSigns.moon.name, { name: birthSigns.moon.name, degree: birthSigns.moon.degree, minute: birthSigns.moon.minute })
		}
	}

	resetState = () => {
		this.setState({ loading: { status: true, text: 'Loading...' } })
		this.props.updateLookup({ variables: { id: this.props.user.id, lookup: emptyState } })
			.then(() => this.setState({ loading: { status: false, text: '' }, data: emptyState }))
			.catch((err) => console.error(err))
	}


	render() {
		const { lang } = this.props.state
		const { loading, data } = this.state
		return (
			<div>
				<Loading status={loading.status} text={loading.text} lang={lang} />
				<Logo {...this.props} />
				<Tab {...this.props} />
				<div className='capps-container'>

					{/* ENTRY */}
					{(data.birthDate.day > 0 || data.birthDate.month > 0 || data.birthDate.year > 0 || data.birthPlace.address !== '' || data.birthTime.hour > -1 || data.birthTime.minute > -1)
						? <div className='capps-footer'><span className='capps-link' onTouchTap={() => this.resetState()}>Reset all fields</span></div>
						: <div className='capps-footer left'>Use this section to quickly lookup the moon sign of any person. Once you’ve looked up the moon sign, what you entered will be saved to this section.</div>
					}
					<div className='capps-height-20' />
					<EntryForm
						birthDate={data.birthDate}
						birthTime={data.birthTime}
						birthPlace={data.birthPlace}
						birthSigns={data.birthSigns}
						updateBirthData={(birthDate, birthPlace, birthTime, birthSigns) => this.updateBirthData(birthDate, birthPlace, birthTime, birthSigns)}
						{...this.props}
					/>

					{/* IN-APP PURCHASE */}
					{this.props.user && !this.props.user.accountPaid &&
						<div>
							<div className='capps-height-20' />
							<Button
								action={() => this.props.redux.nav.setPage('upgrade')}
								text='Get Complete Access'
							/>
						</div>
					}

					{/* LIFE PURPOSE APP */}
					<LifePurposeApp {...this.props} />
				</div>

				<Social />
			</div>
		)
	}
}

export default graphql(lookupUpdateMutation, { name: 'updateLookup' })(Lookup)



// WEBPACK FOOTER //
// ./src/Components/Home/Lookup.js